import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import PageLayout from '../layouts/PageLayout';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

export default class Foreigns extends Component {
  render() {
    return (
        <PageLayout>
            <div className="container my-2">
                <NavLink to='/' className="btn btn-success mt-3">
                    <FontAwesomeIcon icon={faCaretLeft} /> На главную
                </NavLink>
                <h1 className="my-4 title-page-guide">Инструкция для иностранных граждан после зачисления в университет</h1>
            </div>
            
            <div className="container">
                <div className="row">
                    <div className="col-md-10">
                        <div className="guide-box">
                            <p>
                                Все иностранные граждане (кроме граждан Республики Беларусь и граждан, имеющих статусы РВП, РВПО или ВНЖ), въехавшие на территорию РФ должны пройти обязательную дактилоскопическую регистрацию, фотографирование и медицинское освидетельствование (в соответствии с ФЗ РФ №274-ФЗ от 01.07.2021): 
                            </p>
                            <p>
                                Студенты, аспиранты, слушатели - в течение 90 суток с даты въезда на территорию РФ.
                            </p>
                            <p>
                                Иностранные граждане, не прошедшие дактилоскопию и медосвидетельствование в указанный срок, обязаны будут покинуть территорию РФ до истечения 90 дней с момента въезда. Документы данных граждан продлению не подлежат. В продлении визы и миграционного учета будет отказано в соответствии с ФЗ РФ №274-ФЗ от 01.07.2021. В этом случае студент может быть отчислен за нарушение паспортно-визового режима и нарушение миграционного законодательства. 
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <div className="guide-box">
                            <div className="title back_gc1">С инструкцией по дактилоскопии можно ознакомиться на сайте университета:</div>
                            <ul>
                                <li>
                                    <a href="https://tpu.ru/en/education/for-international-students/" target="_blank">на англоязычном сайте</a>
                                </li>
                                <li>
                                    <a href="https://tpu.ru/education/inostrannym-abiturientam/" target="_blank">на русском</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="guide-box">
                            <p>
                                Следует помнить, что срок действия документа, подтверждающего прохождение процедуры дактилоскопии, составляет 10 лет. Срок действия документов о медицинском освидетельствовании – 1 год. Соответственно, необходимо ежегодно в одно и то же время проходить процедуру медицинского освидетельствования с обязательным предоставлением справок в соответствующее подразделение Управления по вопросам миграции УМВД России по Томской области. 
                            </p>
                            <p>
                                Приказ МВД России от 24 мая 2024 г. N 288 “Об утверждении Порядка проведения обязательной государственной дактилоскопической регистрации и фотографирования иностранных граждан и лиц без гражданства, прибывших в Российскую Федерацию в целях, не связанных с осуществлением трудовой деятельности, на срок, превышающий девяносто календарных дней, либо в целях осуществления трудовой деятельности, а также иностранных граждан и лиц без гражданства, желающих въехать в Российскую Федерацию в указанных целях”
                            </p>
                            <p>
                                После прохождения процедуры дактилоскопической регистрации вы получите свидетельство о прохождении дактилоскопической регистрации. Вам нужно будет иметь его при себе так же, как паспорт, миграционную карту и регистрацию, а также предоставить сотруднику университета при следующем продлении срока пребывания.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    )
  }
}
